import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import SecurityIcon from '@mui/icons-material/Security'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'

const Maintenance = () => (
  <OnboardingContainer>
    <Box
      component="main"
      aria-labelledby="maintenance-heading"
      minHeight="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={{ xs: 3, lg: 5 }}
      py={6}
    >
      <Box width="100%" maxWidth={500}>
        <Box
          component="img"
          src="/adnexio-logo-text.svg"
          alt="adnexio logo"
          width={160}
          height={32}
          display={{ xs: 'block', lg: 'none' }}
          mb={5}
        />
        <Box
          display="inline-flex"
          p={2}
          mb={3}
          borderRadius="50%"
          bgcolor="#FFF7D9"
          color="#936600"
        >
          <SecurityIcon sx={{ fontSize: 40 }} />
        </Box>
        <Typography
          component="h1"
          variant="h1"
          id="maintenance-heading"
          fontWeight={700}
          mb={3}
        >
          System is under maintenance
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
          We’re performing maintenance to improve system security. Sign-in is temporarily
          unavailable while we complete these updates.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Please check back later. Thank you for your patience.
        </Typography>
      </Box>
    </Box>
  </OnboardingContainer>
)

export default Maintenance
